<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <!-- Name -->
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('ntechlab.master_account.name')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="itemData.name"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Comment -->
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              name="comment"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('ntechlab.watch_list.comment')"
                label-for="comment"
              >
                <b-form-input
                  id="comment"
                  v-model="itemData.comment"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Color -->
          <b-col cols="6">
            <validation-provider
                #default="validationContext"
                name="color"
                rules="required"
              >
              <b-form-group
                class="text-capitalize"
                :label="$t('alarm_level.color')"
                label-for="color"
              >
              <b-form-input
                id="color"
                v-model="formattedColor"
                :state="getValidationState(validationContext)"
                trim
                type="color"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Master Account -->
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              name="Master Account"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('ntechlab.watch_list.master_account')"
                label-for="id_master_account"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_master_account"
                  :options="masterAccountOptions"
                  :clearable="false"
                  :reduce="option => option.id"
                  input-id="id_master_account"
                  placeholder="Select Master Account"
                  label="name"
                />
                <b-form-invalid-feedback
                  :state="getValidationState(validationContext)"
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Type Alarm -->
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              :name="$t('ntechlab.watch_list.type_alarm')"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('ntechlab.watch_list.type_alarm')"
                label-for="alarm_type"
              >
                <v-select
                  v-model="itemData.alarm_type"
                  :options="typeAlarmsOptions"
                  :clearable="false"
                  :reduce="option => option.id"
                  input-id="alarm_type"
                  label="name"
                  required
                />
                <b-form-invalid-feedback
                  :state="getValidationState(validationContext)"
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Tenant -->
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              name="tenant"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                label="Tenant"
                label-for="tenant"
              >
                <v-select
                  v-model="itemData.tenant_id"
                  :options="tenantOptions"
                  :clearable="false"
                  :reduce="option => option.value"
                  input-id="tenant"
                  label="label"
                  required
                />
                <b-form-invalid-feedback
                  :state="getValidationState(validationContext)"
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Is Blacklist -->
           <b-col cols="6">
            <validation-provider
              #default="validationContext"
              name="is_blacklist"
            >
              <b-form-group
                class="text-capitalize"
                label="Is Blacklist"
                label-for="is_blacklist"
              >
                <b-form-checkbox
                v-model="itemData.is_blacklist"
                :value="true"
                :unchecked-value="false"
                switch
                />
              </b-form-group>
          </validation-provider>
           </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';
import { ref, watch, computed } from '@vue/composition-api';
import vSelect from "vue-select";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    propItemData: {
      type: Object,
      required: true
    },
    masterAccountOptions: {
      type: Array,
      required: true
    },
    typeAlarmsOptions: {
      type: Array,
      required: true
    },
    tenantOptions: {
      type: Array,
      required: true
    }
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();

    const itemData = ref({
      ...JSON.parse(JSON.stringify(props.propItemData))
    });


    const formattedColor = computed({
      get: () => itemData.value.color ? `#${itemData.value.color}` : '',
      set: (val) => {
        itemData.value.color = val.replace('#', '');
      }
    });

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Form observer reference is null");
        return false;
      }

      const validation = await refFormObserver.value.validate();

      // Additional validation check
      if (!itemData.value.name ||
          !itemData.value.comment ||
          !itemData.value.color ||
          !itemData.value.id_master_account) {
        return false;
      }

      return validation;
    };

    const updateItemData = (newData) => {
      Object.assign(itemData.value, newData);
      emit("update:itemData", newData);
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:item-data", { [key]: newValue });
          }
        }
      );
    };

    setupWatcher(itemData, "color");
    setupWatcher(itemData, "id_master_account");
    setupWatcher(itemData, "alarm_type");
    setupWatcher(itemData, "name");
    setupWatcher(itemData, "comment");
    setupWatcher(itemData, "id");
    setupWatcher(itemData, "tenant_id");
    setupWatcher(itemData, "is_blacklist");

    return {
      refFormObserver,
      getValidationState,
      itemData,
      formattedColor,
      validateStep,
      updateItemData
    }
  }
}
</script>
